import React, { useState, useEffect } from 'react';
import styles from './adminStyles.module.css';

function ProductForm({ product, onSave, onCancel }) {
  const [formData, setFormData] = useState({
    name: '',
    image: '',
    description: '',
    price: '',
    quantity: '',
  });

  useEffect(() => {
    if (product) {
      setFormData({
        name: product.name || '',
        image: product.image || '',
        description: product.description || '',
        price: product.price || '',
        quantity: product.quantity || '',
      });
    }
  }, [product]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.price.trim()) return;

    const cleanData = { ...formData };
    if (!cleanData.quantity) delete cleanData.quantity;

    onSave(cleanData);
  };

  return (
    <div className={styles.modalOverlay} onClick={onCancel}>
      <div
        className={styles.modalContent}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className={styles.modalTitle}>
          {product ? '✏️ עריכת מוצר' : '➕ הוספת מוצר'}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>שם המוצר*</label>
            <input
              className={styles.formInput}
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter product name"
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.formLabel}>לינק לתמונה *</label>
            <input
              className={styles.formInput}
              type="url"
              name="image"
              value={formData.image}
              onChange={handleChange}
              placeholder="https://example.com/image.jpg"
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.formLabel}>תיאור</label>
            <textarea
              className={styles.formTextarea}
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter product description"
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.formLabel}>מחיר *</label>
            <input
              className={styles.formInput}
              type="text"
              name="price"
              value={formData.price}
              onChange={handleChange}
              placeholder="e.g. 299"
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.formLabel}>כמות במלאי (optional)</label>
            <input
              className={styles.formInput}
              type="text"
              name="quantity"
              value={formData.quantity}
              onChange={handleChange}
              placeholder="e.g. 5"
            />
          </div>

          <div className={styles.formButtons}>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={onCancel}
            >
              ביטול
            </button>
            <button type="submit" className={styles.submitButton}>
              {product ? 'עדכון' : 'הוספה'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProductForm;
